import { ParticipantData } from "./Participant";
import { User } from "./User";

export enum RegistrationStatus {
  PENDING = "pending",
  DENIED = "denied",
  APPROVED = "approved",
  WAITLIST = "waitlist",
  COMPLETED = "completed",
}

export interface Registration {
  id: string;
  registrationDate: Date;
  status: RegistrationStatus;
  approvalDate?: Date;
  approvedBy: User;
  denialReason: string;
  updatedAt: Date;
  waitlistPosition?: number;
  participant?: ParticipantData;
}
